import React from "react";
import PageHero from "../components/PageHero";
import IndustriesGrid from "../components/IndustriesGrid";
import Testimonials from "../components/Testimonials";
import CyberRiskCTA from "../components/CyberRiskCTA";

export default function IndustriesPage() {
  return (
    <div data-testid="industries-page">
      <PageHero
        eyebrow="Industries"
        title="Industry-specific security & compliance"
        subtitle="Regulated, high-stakes and IP-heavy sectors trust Techmate to translate cyber risk into board-ready outcomes."
      />
      <IndustriesGrid />
      <Testimonials />
      <CyberRiskCTA />
    </div>
  );
}
